const WSI_SOP_CLASS_UIDS = new Set(['1.2.840.10008.5.1.4.1.1.77.1.6']);
export function isWsiInstance(instance) {
    if (WSI_SOP_CLASS_UIDS.has(instance.SOPClassUID ?? '')) {
        return true;
    }
    return instance.Modality === 'SM';
}
